import { h, Component } from 'preact';
import { Link } from "components/core/link/link.js";
import { sortObjectByOrder, joinClasses, accessNested } from 'utils/utils';
import { track } from 'utils/tracking';
import * as actions from 'store/actions';
import Store from 'store/store';
import s from 'components/templates/resources/resources.sss';

export default class Resources extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.handleExtra = this.handleExtra.bind(this);

		const items = Object.keys(props.data.items);
		let itemState = items.reduce((allItems, item) => (
			{
				...allItems,
				[item]: 6
			}
		), {});

		this.state = {
			...itemState
		};
		this.oldChrome = false;
	}

	handleClick(id) {
		const newValue = this.state[id] === Infinity ? 6 : Infinity;
		this.setState({
			[id]: newValue
		});
	}

	handleExtra(id, idx, title, name, destination) {
		Store.emit(actions.NETFLIX_RESOURCE_CLICK, 'resources', title, name, destination);
		track({a: `resource-${id}-${idx}-click`});
	}

	renderItems(id, list, title) {
		return list.map((link, idx) => {
			if(idx < this.state[id]) {
				return(
					<li class={s.listItem}>
						<Link class={joinClasses(s.link, this.oldChrome && s.oldChrome)} href={link.href} extraOnClick={() => this.handleExtra(id, idx, title, link.label, link.href)} target='_blank'>
							{link.label}
						</Link>
					</li>
				);
			}
		});
	}

	render({ data }, state) {
		const {
			title,
			subtitle,
			items
		} = data;

		const { copy } = accessNested(Store.get(), 'appData');
		const { $VIEW_MORE = 'Show More', $VIEW_FEWER = 'Show Less' } = copy;

		return (
			<div class={s.wrapper} id='resources' data-section-observed>
				{title && <h2 class={s.title}>{title}</h2>}
				{subtitle && <p class={s.subtitle}>{subtitle}</p>}
				<div class={s.flex}>
					{
						sortObjectByOrder(items).map(item => {
							const sortedList = sortObjectByOrder(item.list);
							const show = sortedList.length > state[item.id];
							const showBtn = sortedList.length > 6;
							return(
								<ol class={s.items}>
									{item.title && <h3 class={s.itemsTitle}>{item.title}</h3>}
									{this.renderItems(item.id, sortedList, item.title)}
									{showBtn && (
										<div
											class={joinClasses(show && s.active, s.btn)}
											onClick={() => this.handleClick(item.id)}
										>
											{show ? $VIEW_MORE : $VIEW_FEWER }
										</div>
									)}
								</ol>
							);
						})
					}
				</div>
			</div>
		);
	}

}
